import { render, staticRenderFns } from "./HerbGroups.vue?vue&type=template&id=0a142a74&scoped=true"
import script from "./HerbGroups.vue?vue&type=script&lang=js"
export * from "./HerbGroups.vue?vue&type=script&lang=js"
import style0 from "./HerbGroups.vue?vue&type=style&index=0&id=0a142a74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a142a74",
  null
  
)

export default component.exports